var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"avatar",attrs:{"color":_vm.color,"size":_vm.size}},[(_vm.profile_url)?_c('img',{staticClass:"profile-img",attrs:{"src":_vm.profile_url}}):_c('span',{staticClass:"intials"},[_vm._v(_vm._s(_vm.intials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }